import greenJersey from '../assets/images/jerseys/green.svg';
import redJersey from '../assets/images/jerseys/red.svg';
import yellowJersey from '../assets/images/jerseys/yellow.svg';
export const jerseys = ['distance', 'consecutiveDaysCount', 'homeWorkJourneysCount'];
export const jerseysMap = {
  consecutiveDaysCount: {
    labelKey: 'commons.jerseys.consecutive_days_count.title',
    descriptionKey: 'commons.jerseys.consecutive_days_count.description',
    icon: greenJersey,
    color: '#8EEAC2',
    lightColor: '#EEF9F4',
    textColor: '#005A44'
  },
  distance: {
    labelKey: 'commons.jerseys.distance.title',
    descriptionKey: 'commons.jerseys.distance.description',
    icon: yellowJersey,
    color: '#FFE27D',
    lightColor: '#FFF5D0',
    textColor: '#846858'
  },
  homeWorkJourneysCount: {
    labelKey: 'commons.jerseys.home_work_journeys_count.title',
    descriptionKey: 'commons.jerseys.home_work_journeys_count.description',
    icon: redJersey,
    color: '#FFA3A3',
    lightColor: '#FFEDED',
    textColor: '#D34949'
  }
};